import MarkdownText from "./markdown_text"
import styles from "./messages.module.scss"

interface Props {
  text: string
}

const AssistantMessage = ({ text }: Props) => (
  <div className={styles["row"]} data-testid="assistant-message">
    <MarkdownText text={text} />
  </div>
)

export default AssistantMessage
